import { memo } from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

import classes from './UsageExampleSection.module.scss';
import { SectionTitle } from "../SectionTitle/SectionTitle";

/*Image*/
import usageItemImgPe from "../../../assets/images/IMG_3594.png";
import usageItemImgClub from "../../../assets/images/img_what03.jpeg";
import usageItemImgSchoolTrip from "../../../assets/images/img_what02.webp";
import usageItemImgFieldTrip from "../../../assets/images/iMG_133021.jpeg";
import usageItemImgInquiry from "../../../assets/images/iMG_133121.jpeg";
import usageItemImgEvent from "../../../assets/images/IMG_3604.png";

interface Props {
  className?: string;
}

export const UsageExampleSection: FC<Props> = memo(function UsageExampleSection(props = {}) {
  const { t, i18n } = useTranslation();
  const langCode = i18n.language;

  return (
    <section id="usage-example" className={`${classes.usageExample} ${props.className || ''}`}>
      <SectionTitle
        classes={{color:"grad"}}
        text={t('common:usageExample.title')}
      />

      <ul className={`${classes.usageList} contentWidth`}>
        <li className={classes.usageItem}>
          <Link to={`/${langCode}/post/12708`}>
            <img src={usageItemImgPe} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemPe')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descPe" components={{ 1: <br className="sponly" /> }} /></div>
          </Link>
        </li>
        <li className={classes.usageItem}>
          <Link to={`/${langCode}/post/6689`}>
            <img src={usageItemImgClub} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemClub')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descClub" components={{ 1: <br className="sponly" /> }} /></div>
          </Link>
        </li>
        {/* 特設ページは SPA 外の静的ページのため a タグで遷移 */}
        <li className={classes.usageItem}>
          <a href="https://hado-official.com/education/school-trip/">
            <img src={usageItemImgSchoolTrip} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemSchoolTrip')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descSchoolTrip" components={{ 1: <br className="sponly" /> }} /></div>
          </a>
        </li>
        <li className={classes.usageItem}>
          <a href="https://hado-official.com/education/field-trip/">
            <img src={usageItemImgFieldTrip} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemFieldTrip')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descFieldTrip" components={{ 1: <br className="sponly" /> }} /></div>
          </a>
        </li>
        <li className={classes.usageItem}>
          <Link to={`/${langCode}/post/5757`}>
            <img src={usageItemImgInquiry} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemInquiry')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descInquiry" components={{ 1: <br className="sponly" /> }} /></div>
          </Link>
        </li>
        <li className={classes.usageItem}>
          <Link to={`/${langCode}/post/6379`}>
            <img src={usageItemImgEvent} className={classes.usageItemImg} alt="" />
            <div className={classes.usageItemTitle}>{t('common:usageExample.itemEvent')}</div>
            <div className={classes.usageItemText}><Trans i18nKey="common:usageExample.descEvent" components={{ 1: <br className="sponly" /> }} /></div>
          </Link>
        </li>
      </ul>

    </section>
  );
});
